export function getScenesForUpload<T>(scenesCreated: T[] | undefined, scene: T | null | undefined): T[] {
	if (Array.isArray(scenesCreated) && scenesCreated.length > 0) return scenesCreated;
	return scene ? [scene] : [];
}

export function appendSceneId(sceneIds: string[] | undefined, sceneId: string | number): string[] {
	const id = String(sceneId);
	const current = sceneIds || [];
	return current.includes(id) ? current : [...current, id];
}
